import { z } from 'zod';
import { IdSchema } from './common.js';

const numberFormat = z.strictObject({
  type: z.literal('number'),
  decimals: z.number().int().min(0).max(10).optional(),
  thousandsSeparator: z.boolean().optional(),
  compact: z.boolean().optional(),
  prefix: z.string().max(16).optional(),
  suffix: z.string().max(16).optional(),
});
const currencyFormat = z.strictObject({
  type: z.literal('currency'),
  currency: z.string().regex(/^[A-Z]{3}$/, 'Codigo ISO 4217'),
  decimals: z.number().int().min(0).max(10).optional(),
  compact: z.boolean().optional(),
});
const percentFormat = z.strictObject({
  type: z.literal('percent'),
  decimals: z.number().int().min(0).max(10).optional(),
});
const dateFormat = z.strictObject({
  type: z.literal('date'),
  /** Patron Unicode CLDR, por ejemplo `yyyy-MM-dd`. */
  pattern: z.string().min(1).max(64),
});
const textFormat = z.strictObject({ type: z.literal('text') });

/** Especificacion de formato independiente de la libreria de renderizado. */
export const FormatSpecSchema = z.discriminatedUnion('type', [
  numberFormat,
  currencyFormat,
  percentFormat,
  dateFormat,
  textFormat,
]);
export type FormatSpec = z.infer<typeof FormatSpecSchema>;

/** Formato de un objeto: especificacion inline o referencia al catalogo `formats` del modelo. */
export const FieldFormatSchema = z.discriminatedUnion('type', [
  numberFormat,
  currencyFormat,
  percentFormat,
  dateFormat,
  textFormat,
  z.strictObject({ type: z.literal('ref'), formatId: IdSchema }),
]);
export type FieldFormat = z.infer<typeof FieldFormatSchema>;

export const FormatDefinitionSchema = z.strictObject({
  id: IdSchema,
  name: z.string().min(1).max(200),
  description: z.string().max(2000).optional(),
  spec: FormatSpecSchema,
});
export type FormatDefinition = z.infer<typeof FormatDefinitionSchema>;
